module.exports = __webpack_public_path__ + "static/media/landding01.e78f3fa0.png";